import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'brightside-web-financial-accounts-core-main',
    templateUrl: './financial-accounts-core-main.component.html',
    styleUrls: ['./financial-accounts-core-main.component.css'],
    standalone: false
})
export class FinancialAccountsCoreMainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
